import React from 'react';
import { Toaster } from 'react-hot-toast';

const ToastProvider = () => {
  return <Toaster position="top-right" reverseOrder={false} gutter={16} />;
};

export { ToastProvider };
